"use client";

import * as React from "react";
import { ChevronsRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { CanvasCourse } from "@/lib/types";

type CourseAssignmentInlineProps = {
  course?: CanvasCourse;
  assignmentName?: string;
  className?: string;
  color?: boolean;
  colorSize?: "small" | "medium";
};

export function CourseAssignmentInline({
  course,
  assignmentName,
  className,
  color = true,
  colorSize = "small",
}: CourseAssignmentInlineProps) {
  if (!course && !assignmentName) return null;
  const courseName = course.code || course.default;

  const circleStyle = {
    small: "h-2 w-2",
    medium: "h-3 w-3",
  };

  return (
    <div className={cn("flex items-center gap-2 min-w-0 pr-4", className)}>
      {color && (
        <div
          className={cn(
            "rounded-full shrink-0 group-data-[collapsible=icon]:hidden",
            circleStyle[colorSize]
          )}
          style={{ backgroundColor: course?.color || "#ffffff80" }}
        />
      )}
      <div className={cn("flex items-center gap-1 min-w-0 flex-1")}>
        {courseName && (
          <p className="text-xs text-theme-1 truncate" title={courseName}>
            {courseName}
          </p>
        )}

        {courseName && assignmentName && (
          <ChevronsRight className="h-4 w-4 shrink-0 text-theme-2" />
        )}

        {assignmentName && (
          <p className="text-xs text-theme-1 truncate" title={assignmentName}>
            {assignmentName}
          </p>
        )}
      </div>
    </div>
  );
}
